import React from 'react'
import Icon from '../Icon'
import './ui.css'

function Toast ({
  message,
  visible = Boolean(message),
  className = '',
}) {
  if (!message) return null

  return (
    <div
      className={`ds-toast ${visible ? 'ds-toast--show' : ''} ${className}`.trim()}
      role="status"
      aria-live="polite"
    >
      <span className="ds-toast__icon" aria-hidden>
        <Icon name="check" size={11} />
      </span>
      <span>{message}</span>
    </div>
  )
}

export default Toast
